const links = [
    { name: "Inicio", path: "/" },
    { name: "Servicios", path: "/servicios" },
    { name: "Contacto", path: "/contacto" },
    { name: "Acerca de", path: "/acerca" },
];

export default links;